export default "__VITE_ASSET__CANlc0tT__"